import {
  mdiClose,
  mdiPencil,
  mdiDrag,
  mdiCheckboxOutline,
  mdiCheckboxBlankOutline,
  mdiCloseBoxOutline
} from '@mdi/js'

export default {
  'freshvuecards-close': mdiClose,
  'freshvuecards-edit': mdiPencil,
  'freshvuecards-drag': mdiDrag,

  'freshvuecard-process-completed': mdiCheckboxOutline,
  'freshvuecard-process-uncompleted': mdiCheckboxBlankOutline,
  'freshvuecard-process-missing': mdiCloseBoxOutline
}
